export enum UpdatePopUpEnum {
    Capacity = "Capacity",
    Demand = "Demand",
    Actual = "Actual",
  }